import { render } from "./CompanyBadge.vue?vue&type=template&id=00898568&scoped=true"
import script from "./CompanyBadge.vue?vue&type=script&lang=js"
export * from "./CompanyBadge.vue?vue&type=script&lang=js"

import "./CompanyBadge.vue?vue&type=style&index=0&id=00898568&scoped=true&lang=css"

import exportComponent from "/Users/felix/dev/projects/protfolio/schillerando-demo/schillerando-demo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00898568"]])

export default __exports__